import React from "react";
import { Typography, Button } from "antd";
import {
  UserOutlined,
  UserAddOutlined,
} from "@ant-design/icons";

const { Title, Paragraph } = Typography;

function GetStartedCtaSection({ openTrialSignup, openSignup }) {
  const handlePrimaryClick = () => {
    if (typeof openTrialSignup === "function") {
      openTrialSignup("");
    } else if (typeof openSignup === "function") {
      openSignup(true);
    }
  };

  const handleDemoClick = () => {
    if (typeof openTrialSignup === "function") {
      openTrialSignup("1-on-1 Product Walkthrough");
    }
  };

  return (
    <section className="get-started-cta" id="cta-banner">
      <div className="orbit-cta-banner">
        <div className="orbit-cta-grid">
          {/* Left Column: Typography & Action Buttons */}
          <div className="orbit-cta-left">
            <span className="orbit-cta-eyebrow">Ready to Scale?</span>
            <Title level={2} className="orbit-cta-headline">
              Ready to Eliminate Pipeline Leakage &amp; Accelerate Your Sales Velocity?
            </Title>
            <Paragraph className="orbit-cta-subheading">
              Join fast-growing sales teams closing deals faster with automated telephony telemetry, stagnant deal radar, and 1-click GST payments.
            </Paragraph>

            <div className="orbit-cta-buttons">
              <Button
                size="large"
                className="orbit-btn-white"
                onClick={handleDemoClick}
              >
                Need 1-on-1 Help?
              </Button>

              <Button
                size="large"
                className="orbit-btn-blue"
                onClick={handlePrimaryClick}
              >
                Start Free Trial
              </Button>
            </div>
          </div>

          {/* Right Column: Rotating Orbit Circles Axis with Avatars */}
          <div className="orbit-cta-right">
            <div className="orbit-system-wrapper">
              {/* Center Pill */}
              <div className="orbit-center-pill">
                <span>Extend your team</span>
              </div>

              {/* Inner Orbit Ring */}
              <div className="orbit-ring orbit-ring-inner">
                {/* Node 1: Top Right */}
                <div className="orbit-node node-inner-1">
                  <div className="orbit-avatar-wrap avatar-halo-blue">
                    <img
                      src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=120&auto=format&fit=crop&q=80"
                      alt="Team Rep"
                      className="orbit-avatar-img"
                    />
                  </div>
                </div>

                {/* Node 2: Bottom Left */}
                <div className="orbit-node node-inner-2">
                  <div className="orbit-avatar-wrap avatar-halo-cyan">
                    <img
                      src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=120&auto=format&fit=crop&q=80"
                      alt="Team Rep"
                      className="orbit-avatar-img"
                    />
                  </div>
                </div>

                {/* Node 3: Left */}
                <div className="orbit-node node-inner-3">
                  <div className="orbit-avatar-wrap avatar-small">
                    <img
                      src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=120&auto=format&fit=crop&q=80"
                      alt="Team Rep"
                      className="orbit-avatar-img"
                    />
                  </div>
                </div>
              </div>

              {/* Outer Orbit Ring */}
              <div className="orbit-ring orbit-ring-outer">
                {/* Node 1: Top Right User Icon Badge */}
                <div className="orbit-node node-outer-1">
                  <div className="orbit-avatar-wrap avatar-icon-badge">
                    <UserOutlined />
                  </div>
                </div>

                {/* Node 2: Right / East Green Ring */}
                <div className="orbit-node node-outer-2">
                  <div className="orbit-avatar-wrap avatar-halo-green">
                    <img
                      src="https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=120&auto=format&fit=crop&q=80"
                      alt="Team Rep"
                      className="orbit-avatar-img"
                    />
                  </div>
                </div>

                {/* Node 3: Bottom Right User Add Badge */}
                <div className="orbit-node node-outer-3">
                  <div className="orbit-avatar-wrap avatar-icon-add-badge">
                    <UserAddOutlined />
                  </div>
                </div>

                {/* Node 4: Far Right Small Avatar */}
                <div className="orbit-node node-outer-4">
                  <div className="orbit-avatar-wrap avatar-small">
                    <img
                      src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=120&auto=format&fit=crop&q=80"
                      alt="Team Rep"
                      className="orbit-avatar-img"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default GetStartedCtaSection;
